/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const validationWorkflowUpdateRequestNameMax = 256;

export const validationWorkflowUpdateRequestDescriptionMax = 1024;

export const ValidationWorkflowUpdateRequest = zod.strictObject({
    name: zod.string().min(1).max(validationWorkflowUpdateRequestNameMax),
    description: zod
        .string()
        .max(validationWorkflowUpdateRequestDescriptionMax)
        .optional(),
    forms: zod.array(zod.number()).optional(),
});

export type ValidationWorkflowUpdateRequest = zod.input<
    typeof ValidationWorkflowUpdateRequest
>;
export type ValidationWorkflowUpdateRequestOutput = zod.output<
    typeof ValidationWorkflowUpdateRequest
>;
